<template>
  <div style="text-align: left">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item>
        <el-row>
          <el-col :span="1">区域</el-col>
          <el-col :span="6">
            <el-select v-model="form.province" placeholder="请选择" @change="provinceChanged">
              <el-option
                v-for="item in provinces"
                :key="item"
                :label="nameMappings[item]"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.city" placeholder="请选择" @change="cityChanged">
              <el-option
                v-for="item in cities"
                :key="item"
                :label="nameMappings[item]"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-select v-model="form.district" placeholder="请选择">
              <el-option
                v-for="item in districts"
                :key="item"
                :label="nameMappings[item]"
                :value="item">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="1">姓名</el-col>
          <el-col :span="4">
            <el-input v-model="form.name" placeholder="请输入姓名">
            </el-input>
          </el-col>
          <el-col :span="1" :offset="1">电话</el-col>
          <el-col :span="5">
            <el-input v-model="form.mobile" placeholder="请输入电话号码">
            </el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item>
        <el-row>
          <el-col :span="6">
            <el-radio-group v-model="form.buy">
              <el-radio label="0">非会员</el-radio>
              <el-radio label="1">会员</el-radio>
              <el-radio label="">所有</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :offset="14" :span="2">
            <el-button type="primary" @click="onQuery"><i class="el-icon-search"></i> 查询</el-button>
          </el-col>
        </el-row>

      </el-form-item>
    </el-form>

    <el-table
      :data="userList"
      border
      style="width: 100%">
      <el-table-column
        fixed
        label="编号"
        width="150">
        <template slot-scope="scope">
          <router-link :to="{path: '/user/details', query: {id: scope.row.id}}">{{scope.row.id}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120">
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="昵称"
        width="120">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="电话"
        width="200">
      </el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        width="120">
        <template slot-scope="scope">
          {{ scope.row.province ? (nameMappings ? nameMappings[scope.row.province] : scope.row.province) : '' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="city"
        label="市区"
        width="180">
        <template slot-scope="scope">
          {{ scope.row.city ? (nameMappings ? nameMappings[scope.row.city] : scope.row.city) : '' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="district"
        label="地区"
        width="120">
        <template slot-scope="scope">
          {{ scope.row.district ? (nameMappings ? nameMappings[scope.row.district] : scope.row.district) : '' }}
        </template>
      </el-table-column>
      <el-table-column
        sortable
        prop="balance"
        label="余额"
        width="120">
        <template slot-scope="scope">
          {{ scope.row.balance / 100 }} 元
        </template>
      </el-table-column>
      <el-table-column
        label="注册时间"
        width="200">
        <template slot-scope="scope">
          {{ scope.row.et.substring(0, 10) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="buy"
        label="会员"
        width="120">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.buy == '0' ? 'primary' : 'success'"
            disable-transitions>{{scope.row.buy == '0' ? '非会员' : '会员'}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      v-if="totalElements > 0"
      background
      layout="prev, pager, next"
      @current-change="handlePageChange"
      :current-page.sync="form.page"
      :page-size="form.pageSize"
      :total="totalElements">
    </el-pagination>
  </div>

</template>

<script>
import * as api from "@/js/api.js";

export default {
  name: "UserList",
  data() {
    return {
      form: {
        name: '',
        mobile: '',
        province: '',
        city: '',
        district: '',
        buy: '',
        page: 1,
        pageSize: 50
      },
      userList: [],
      nameMappings: {},
      regionInfo: {},
      provinces: [],
      cities: [],
      districts: [],
      totalElements: 0,
    }
  },
  methods: {
    handlePageChange() {
      this.onQuery()
    },
    onQuery() {
      const query = this.form
      api.userQuery(query).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求区域信息出错');
        } else {
          this.userList = result.data.content
          this.totalElements = result.data.totalElements
        }
      })
    },
    provinceChanged() {
      this.cities = this.regionInfo.provinceCityMapping[this.form.province]
      this.form.district = ''
      this.form.city = ''
      this.districts = []
    },
    cityChanged() {
      this.districts = this.regionInfo.cityDistrictMapping[this.form.city]
      this.form.district = ''
    }
  },
  mounted() {
    let that = this
    if (this.$store.state.RegionInfo) {
      this.regionInfo = this.$store.state.RegionInfo
      this.provinces = this.regionInfo.provinces
      this.nameMappings = this.regionInfo.codeNameMappings
    } else {
      api.getRegions({}).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('请求区域信息出错');
        } else {

          this.regionInfo = result.data
          this.provinces = result.data.provinces
          this.nameMappings = result.data.codeNameMappings

          that.$store.commit('update', ['RegionInfo', this.regionInfo])
        }
      })
    }

    this.onQuery()
  },
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/users/UserList.vue